"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HazardInsuranceBannerType = exports.HazardInsuranceRejectionReason = exports.HazardInsuranceReviewResult = void 0;
/**
 * Outcome of an ops/system review of a homeowner's (hazard) insurance declarations page. Canonical
 * here in aven_types so the backend entity (`HomeOwnerInsurance.documentReviewResult`), the API
 * contract, and the partner dashboard all share one source of truth. The backend entity type file
 * re-exports this — string values must stay byte-identical (TypeORM column values depend on them).
 */
var HazardInsuranceReviewResult;
(function (HazardInsuranceReviewResult) {
    HazardInsuranceReviewResult["approved"] = "approved";
    HazardInsuranceReviewResult["pending"] = "pending";
    HazardInsuranceReviewResult["rejected"] = "rejected";
})(HazardInsuranceReviewResult || (exports.HazardInsuranceReviewResult = HazardInsuranceReviewResult = {}));
/**
 * Structured reasons a homeowner's (hazard) insurance policy was rejected during review. These map
 * 1:1 to what ops agents actually request from borrowers over Zendesk (e.g. an updated declarations
 * page with the correct mortgagee/loss-payee clause, or higher dwelling coverage). Surfaced in the
 * partner-dashboard hazard-insurance click-in so the LO can see exactly what's wrong with a policy
 * without digging through support tickets. Canonical here; the backend entity re-exports it (values
 * must stay byte-identical).
 */
var HazardInsuranceRejectionReason;
(function (HazardInsuranceRejectionReason) {
    /** Coverage period leaves a gap (e.g. expired/expiring, or not continuous with the prior policy). */
    HazardInsuranceRejectionReason["insufficientCoverageDuration"] = "insufficientCoverageDuration";
    /** Dwelling coverage amount is below the required minimum (the borrower's approved line size). */
    HazardInsuranceRejectionReason["insufficientCoverageAmount"] = "insufficientCoverageAmount";
    /** The uploaded document isn't a valid declarations page (e.g. a screenshot, invoice, or quote). */
    HazardInsuranceRejectionReason["wrongDocument"] = "wrongDocument";
    /** Missing or incorrect mortgagee/loss-payee clause (Coastal Community Bank ISAOA …). */
    HazardInsuranceRejectionReason["incorrectLossPayee"] = "incorrectLossPayee";
    /** The insured address on the policy doesn't match the property. */
    HazardInsuranceRejectionReason["incorrectInsuredAddress"] = "incorrectInsuredAddress";
    /** The property description on the policy doesn't match. */
    HazardInsuranceRejectionReason["incorrectPropertyDescription"] = "incorrectPropertyDescription";
    /** The named insured on the policy doesn't match the applicant(s). */
    HazardInsuranceRejectionReason["incorrectNameOnThePolicy"] = "incorrectNameOnThePolicy";
    /** A condo policy is missing the association's master policy declarations page. */
    HazardInsuranceRejectionReason["missingCondoMasterPolicy"] = "missingCondoMasterPolicy";
    /** The uploaded policy is not current (expired or not yet in effect). */
    HazardInsuranceRejectionReason["currentPolicyRequired"] = "currentPolicyRequired";
})(HazardInsuranceRejectionReason || (exports.HazardInsuranceRejectionReason = HazardInsuranceRejectionReason = {}));
var HazardInsuranceBannerType;
(function (HazardInsuranceBannerType) {
    HazardInsuranceBannerType["beforeAccountOpening"] = "beforeAccountOpening";
    HazardInsuranceBannerType["uploadByDate"] = "uploadByDate";
    HazardInsuranceBannerType["dueToday"] = "dueToday";
})(HazardInsuranceBannerType || (exports.HazardInsuranceBannerType = HazardInsuranceBannerType = {}));
